/**
 * @description: 抽奖管理路由文件
 * @author: lx
 * @Compile：2023-09-11 13：00
 * @update: lx(2023-09-11 13：00)
 */
export default [
  // 奖品信息设置
  {
    path: '/lotteryPrize',
    component: resolve => require(['../../pages/pages_ports_v3/lotteryManage/lotteryPrize/lotteryPrize.vue'], resolve),
    name: 'lotteryPrize',
    title: "奖品信息设置",
    meta: {
      title: "奖品信息设置"
    }
  },
  // 转盘样式管理
  {
    path: '/lotteryStyle',
    component: resolve => require(['../../pages/pages_ports_v3/lotteryManage/lotteryStyle/lotteryStyle.vue'], resolve),
    name: 'lotteryStyle',
    title: "转盘样式管理",
    meta: {
      title: "转盘样式管理"
    }
  },
  // 转盘设置管理
  {
    path: '/lotterySettings',
    component: resolve => require(['../../pages/pages_ports_v3/lotteryManage/lotterySettings/lotterySettings.vue'], resolve),
    name: 'lotterySettings',
    title: "转盘设置管理",
    meta: {
      title: "转盘设置管理"
    }
  },
  // 抽奖记录管理
  {
    path: '/lotteryRecords',
    component: resolve => require(['../../pages/pages_ports_v3/lotteryManage/lotteryRecords/lotteryRecords.vue'], resolve),
    name: 'lotteryRecords',
    title: "抽奖记录管理",
    meta: {
      title: "抽奖记录管理"
    }
  }
]